import React, { useState, useEffect } from 'react';
import {
    Box,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Avatar,
    Chip,
    TableContainer,
    Paper,
    Skeleton
} from '@mui/material';
import SingleColorProgress from '../progress-bar/SingleColorProgress';
import MultiColorProgressBar from '../progress-bar/MultiColorProgressBar';
import moment from 'moment';
const projects = [
    { name: 'SkyGrid', color: '#6A1B9A' },
    { name: 'TerraGear', color: '#FF8F00' },
    { name: 'BlueGroove', color: '#00C853' },
    { name: 'FlowGrid', color: '#D500F9' },
    { name: 'RiverGate', color: '#D50000' }
];


const timeLogs = [
    ["2:00:00", "3:15:00", "4:30:00", "-", "-", "-", "-"],
    ["1:00:00", "2:20:00", "2:45:00", "-", "-", "-", "-"],
    ["3:00:00", "1:45:00", "2:30:00", "-", "-", "-", "-"],
    ["0:30:00", "2:10:00", "1:25:00", "-", "-", "-", "-"],
    ["4:00:00", "3:30:00", "2:15:00", "-", "-", "-", "-"]
];

const allTotals = ["10:30:00", "12:00:00", "13:00:00", "-", "-", "-", "-"];
const overallTotal = "62:30:00";

const WeeklyTimeSheet = ({ WeeklyDate }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 2000);
        return () => clearTimeout(timer);
    }, []);

    const segments = [
        { color: '#0076FE', value: 50 },  // 50% - Focus Time
        { color: '#00C49F', value: 30 },  // 30% - Meetings
        { color: '#FFBB28', value: 20 },  // 20% - Breaks
    ];

    //weekly dateset start//
    // Get the Monday of the selected week
    const startOfWeek = moment(WeeklyDate).startOf("week").add(1, "day"); // Monday
    const endOfWeek = moment(WeeklyDate).endOf("week").add(1, "day"); // Sunday

    const days = [];
    for (let i = 0; i < 7; i++) {
        const d = moment(startOfWeek).add(i, "days");
        days.push({
            day: d.format("ddd"), // Mon, Tue, etc.
            date: d.format("DD"), // 01, 02, etc.
        });
    }

    // highlight current day if within the same week
    const currentDayIndex = moment().isBetween(startOfWeek, endOfWeek, "day", "[]")
        ? moment().diff(startOfWeek, "days")
        : -1;

    //wekly dateset end//

    return (
        <>
            <Box className="card-body p-20 bg-base border rounded-3 " sx={{ display: 'flex', }}>
                <SingleColorProgress timeStr="26:25:43" targetHours={40} />
                <Box sx={{ paddingLeft: '20px', marginLeft: '20px', width: '100%', borderLeft: '1px solid #ccc', }}> <MultiColorProgressBar
                    segments={segments}
                    totalLabel="Total for March"
                    totalTime="2108:18:45"
                /></Box>
            </Box>
            <Box className="card-body px-20 bg-base border rounded-3 mt-24">
                <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: 'none', overflowX: 'auto' }}>
                    <Table
                        sx={{
                            minWidth: 1000,
                            borderCollapse: 'collapse',
                            '& td, & th': {
                                borderBottom: 'none',
                                borderRight: '1px solid #e0e0e0',
                                padding: '8px',
                            },
                            '& td:last-child, & th:last-child': {
                                borderRight: 'none'
                            }
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: 14,
                                        textAlign: 'center',
                                        color: '#1A1F36',
                                        position: 'sticky',
                                        left: 0,
                                        zIndex: 2,
                                        backgroundColor: '#fff'
                                    }}
                                >
                                    {moment(WeeklyDate).format("MMM, YYYY")}
                                </TableCell>
                                {days.map((d, i) => (
                                    <TableCell
                                        key={i}
                                        align="center"
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                            bgcolor:
                                                i === currentDayIndex
                                                    ? '#E8F0FE'
                                                    : i === 5 || i === 6
                                                        ? '#FAFAFA'
                                                        : 'inherit',
                                            borderTop: i === currentDayIndex ? '4px solid #0076FE' : 'inherit',
                                            padding: '6px 8px'
                                        }}
                                    >
                                        <Box>
                                            <Typography fontSize={16} color={'#919095'} fontWeight={500} textTransform={'uppercase'}>
                                                {d.day}
                                            </Typography>
                                            <Typography fontSize={20} color={'#1A1F36'} fontWeight={700}>
                                                {d.date}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                ))}
                                <TableCell
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: 14,
                                        textAlign: 'center',
                                        position: 'sticky',
                                        right: 0,
                                        zIndex: 2,
                                        backgroundColor: '#fff'
                                    }}
                                >
                                    TOTAL
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading
                                ? [...Array(5)].map((_, rowIdx) => (
                                    <TableRow key={rowIdx}>
                                        <TableCell
                                            sx={{
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 1,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Skeleton variant="circular" width={28} height={28} />
                                                <Box>
                                                    <Skeleton width={80} height={16} />
                                                    <Skeleton width={60} height={12} />
                                                </Box>
                                            </Box>
                                        </TableCell>
                                        {days.map((_, i) => (
                                            <TableCell key={i}>
                                                <Skeleton variant="rounded" width={100} height={55} />
                                            </TableCell>
                                        ))}
                                        <TableCell
                                            sx={{
                                                position: 'sticky',
                                                right: 0,
                                                zIndex: 1,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <Skeleton width={60} />
                                        </TableCell>
                                    </TableRow>
                                ))
                                : projects.map((project, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell
                                            sx={{
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 1,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Avatar sx={{ bgcolor: project.color, width: 28, height: 28, fontSize: 13 }}>
                                                    {project.name[0]}
                                                </Avatar>
                                                <Box>
                                                    <Typography fontWeight={600} fontSize={13}>
                                                        {project.name}
                                                    </Typography>
                                                    <Typography fontSize={11} color="text.secondary">
                                                        Workload Dock {idx + 1}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                        {timeLogs[idx].map((time, i) => (
                                            <TableCell
                                                key={i}
                                                align="center"
                                                sx={{
                                                    bgcolor:
                                                        i === currentDayIndex
                                                            ? '#E8F0FE'
                                                            : i === 5 || i === 6
                                                                ? '#FAFAFA'
                                                                : 'inherit'
                                                }}
                                            >
                                                <Chip
                                                    label={time}
                                                    sx={{
                                                        fontSize: 13,
                                                        height: '55px',
                                                        width: '100px',
                                                        borderRadius: 20,
                                                        borderColor: '#E6E6E6',
                                                        bgcolor: i === currentDayIndex ? '#fff' : '#F6F6F6'
                                                    }}
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                        ))}
                                        <TableCell
                                            sx={{
                                                textAlign: 'center',
                                                position: 'sticky',
                                                right: 0,
                                                zIndex: 1,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <Typography fontWeight={600} fontSize={13}>
                                                {timeLogs[idx]
                                                    .filter(t => t !== "-")
                                                    .reduce((total, time) => {
                                                        const [h, m, s] = time.split(":").map(Number);
                                                        return total + h * 3600 + m * 60 + s;
                                                    }, 0)}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}

                            {!loading && (
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            position: 'sticky',
                                            left: 0,
                                            zIndex: 1,
                                            backgroundColor: '#fff'
                                        }}
                                    >
                                        <Box sx={{ borderTop: '1px solid #ccc', padding: '30px 8px' }}>
                                            <Typography fontWeight={600} fontSize={16} color="#1A1F36" textAlign="center">
                                                All projects
                                            </Typography>
                                        </Box>
                                    </TableCell>

                                    {allTotals.map((time, i) => (
                                        <TableCell
                                            key={i}
                                            align="center"
                                            sx={{
                                                bgcolor:
                                                    i === currentDayIndex
                                                        ? '#E8F0FE'
                                                        : i === 5 || i === 6
                                                            ? '#FAFAFA'
                                                            : 'inherit'
                                            }}
                                        >
                                            <Box sx={{ borderTop: '1px solid #ccc', padding: '30px 8px' }}>
                                                <Typography fontSize={13}>{time}</Typography>
                                            </Box>
                                        </TableCell>
                                    ))}

                                    <TableCell
                                        sx={{
                                            position: 'sticky',
                                            right: 0,
                                            zIndex: 1,
                                            backgroundColor: '#fff'
                                        }}
                                    >
                                        <Box sx={{ borderTop: '1px solid #ccc', padding: '30px 8px', textAlign: 'center' }}>
                                            <Typography fontWeight={600} fontSize={14} color="primary">
                                                {overallTotal}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    );
};

export default WeeklyTimeSheet;